import { useEffect, useRef, useState } from 'react'

/**
 * Animate a number from 0 → target with easeOutCubic.
 * Returns the current (rounded to `decimals`) value.
 */
export default function useCountUp(target, { duration = 1100, decimals = 0, active = true } = {}) {
  const [value, setValue] = useState(0)
  const rafRef = useRef()

  useEffect(() => {
    if (!active) {
      setValue(target)
      return
    }
    const factor = Math.pow(10, decimals)
    let startTime

    const tick = (now) => {
      if (startTime === undefined) startTime = now
      const progress = Math.min((now - startTime) / duration, 1)
      const eased = 1 - Math.pow(1 - progress, 3) // easeOutCubic
      setValue(Math.round(target * eased * factor) / factor)
      if (progress < 1) rafRef.current = requestAnimationFrame(tick)
    }

    rafRef.current = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(rafRef.current)
  }, [target, duration, decimals, active])

  return value
}
